<div class="layout-container" [dir]="localeDirection$ | async">
	<ng-container #container></ng-container>
</div>

<!-- GOOGLE RECAPTCHA INVISIBLE -->
<div id="google-recaptcha-invisible"></div>
